import script from "./empty.vue?vue&type=script&setup=true&lang=ts"
export * from "./empty.vue?vue&type=script&setup=true&lang=ts"

import "./empty.vue?vue&type=style&index=0&id=2a07f7ba&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a07f7ba"]])

export default __exports__